<ac-layer acFor="let html of htmls$" [context]="this">
    <ac-html-desc props="{position: html.position, show: html.show}">
        <ng-template let-html>
            <div
                class="popup-close"
                (click)="closePopup()"
                *ngIf="html.id != '0'"
            >
                X
            </div>
            <div class="pop-up" *ngIf="html.id != '0'">
                <div class="popup-row">
                    <div class="popup-title">Latitude:</div>
                    <div class="popup-value">{{ html.data.latitude }}</div>
                </div>
                <div class="popup-row">
                    <div class="popup-title">Longitude:</div>
                    <div class="popup-value">{{ html.data.longitude }}</div>
                </div>
                <div
                    class="popup-row"
                    *ngIf="filterOptions.filterValues.sampleTypeId === 1"
                >
                    <div class="popup-title">Sampling depth(s) (m):</div>
                    <div class="popup-value">{{ html.data.samplingDepth }}</div>
                </div>
                <div class="popup-row">
                    <div class="popup-title">Sampling year(s):</div>
                    <div class="popup-value">{{ html.data.samplingYear }}</div>
                </div>
                <div class="popup-row">
                    <div class="popup-title">Nuclide(s):</div>
                    <div class="popup-value">
                        {{ addSpace(html.data.nuclides) }}
                    </div>
                </div>
                <div
                    class="popup-row"
                    *ngIf="filterOptions.filterValues.sampleTypeId === 2"
                >
                    <div class="popup-title">Biogroup(s):</div>
                    <div class="popup-value">{{ html.data.bioGroup }}</div>
                </div>
                <div
                    class="popup-row"
                    *ngIf="filterOptions.filterValues.sampleTypeId === 2"
                >
                    <div class="popup-title">Number of taxons:</div>
                    <div class="popup-value">
                        {{ html.data.numberOfTaxons }}
                    </div>
                </div>
                <div class="popup-row">
                    <div class="popup-title">Number of datasets:</div>
                    <div class="popup-value">
                        {{ html.data.numberOfDatasets }}
                    </div>
                </div>
                <div class="popup-row">
                    <div class="popup-title">Number of samples:</div>
                    <div class="popup-value">
                        {{ html.data.numberOfSamples }}
                    </div>
                </div>
                <div class="popup-row">
                    <div class="popup-title">Number of measurements:</div>
                    <div class="popup-value">
                        {{ html.data.numberOfMeasures }}
                    </div>
                </div>
                <div class="popup-row"></div>
                <div class="popup-row button-wrapper">
                    <a class="btn btn-primary" (click)="openDialog()">
                        Download selected data
                    </a>
                </div>
            </div>
            <div
                id="container"
                *ngIf="html.data.showDialog"
                class="display-dialog"
            >
                <div class="dialog">
                    <div *ngComponentOutlet="html.activeComponent"></div>
                </div>
            </div>
        </ng-template>
    </ac-html-desc>
</ac-layer>
